<template>
  <div class="cancel_panel ms-controller">
    <el-breadcrumb separator="/" class="bc-nav noborder">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>物流圈</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/abnomalLocation' }">异常定位管理</el-breadcrumb-item>
      <el-breadcrumb-item>添加地址白名单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="map-warp" :style="heightObj">
      <el-amap
        vid="amap-vue-track"
        ref="trackMap"
        :center="amap.center"
        :amap-manager="amapManager"
        :zoom="amap.zoom"
        :events="mapEvents"
      >
        <el-amap-marker v-for="(marker, index) in geopoints" :key="index" :position="marker.lnglat">
          <div class="map-icon-common" @click.stop="showWindowinfo(marker)">
            <span> {{ marker.abnormalPointNum }}</span>
          </div>
        </el-amap-marker>
      </el-amap>
    </div>

    <el-dialog :visible.sync="showAddressLabelTip" title="确认加入白名单" custom-class="tip-dialog">
      <span>请选择地址类型（选填）</span>
      <el-select v-model="addressLabel" placeholder="请选择" style="width: 180px" filterable>
        <el-option
          v-for="(item, idx) in addressLabelList"
          :key="idx"
          :label="item.addressLabelValue"
          :value="item.addressLabelKey"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="primary" @click="hanldeAdd">确认加入白名单</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue';
import VueAMap from 'vue-amap';
import axiosNew from '@/api/axiosNew';
import { WUYI, vali } from '@/api/common';
import api from '@/api/logistics.api';
import eventIdMap from '@/views/logistics/eventIdMap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'b9ca46cb108c4f95b883c5de0c070f6b',
  plugin: ['AMap.Geocoder']['AMap.MarkerClusterer'],
  v: '1.4.13'
});
export default {
  name: 'AbnomalLocationAdd',
  data() {
    return {
      addressNow: '', // 地图点击当前点信息
      marker: {}, // 当前点
      geocoder: null, //  Geocoder实例
      amapManager: null, // 地图实体
      addressLabel: '', // 地址类型
      showAddressLabelTip: false,
      geopoints: [], // 异常点集合
      addressLabelList: [],
      amap: {
        zoom: 4,
        center: [116.303843, 39.983412]
      },
      mapEvents: {
        init: async map => {
          this.amapManager = map;
          this.init();
        },
        click: () => {
          this.infoWindow.close();
        }
      },
      heightObj: {
        height: window.innerHeight - 60 - 58 - 20 + 'px'
      }
    };
  },
  created() {
    window.$vm = this;
  },
  methods: {
    async init() {
      this.infoWindow = new AMap.InfoWindow({
        anchor: 'top-left',
        isCustom: true,
        autoMove: true,
        offset: new AMap.Pixel(25, -46)
      });
      this.amapManager.plugin('AMap.Geocoder', () => {
        this.geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          city: '全国'
        });
      });
      this.fetchData();
    },
    fetchData() {
      axiosNew.post(api.queryAbnormalGeopointList).then(res => {
        this.geopoints = res.data.abnormalGeopointRspList;
        this.$nextTick(() => {
          this.amapManager.setFitView();
        });
      });
    },
    showWindowinfo(marker) {
      this.marker = marker;
      this.getMapAddress();
    },
    // 逆向地理编码
    getMapAddress() {
      this.geocoder.getAddress(this.marker.lnglat, (status, result) => {
        if (status === 'complete' && result.info === 'OK') {
          this.addressNow = result.regeocode;
          this.renderLocation();
        } else {
          this.$message.error('未知地点');
        }
      });
    },
    // 显示地图点击信息
    renderLocation() {
      let content = `<div class="map-location-tip">
                        <span class="location-addr">${this.addressNow.formattedAddress}</span>
                        <span class="join-btn font-blue pointer" onclick="addFn()">加入白名单</span>
                    </div>`;
      this.infoWindow.setContent(content);
      this.infoWindow.open(this.amapManager, this.marker.lnglat);
    },
    // 查询白名单地址标签
    queryAddressLabel() {
      this.addressLabel = '';
      axiosNew.post(api.queryWhiteListAddressLabel).then(res => {
        this.addressLabelList = res.data;
        this.showAddressLabelTip = true;
      });
    },
    // 添加地址白名单
    hanldeAdd() {
      let options = {
        longitude: `${this.marker.lnglat[0]}`,
        latitude: `${this.marker.lnglat[1]}`,
        addressLabel: this.addressLabel ? this.addressLabel : 0
      };
      axiosNew.post(api.addWhiteListAddress, options).then(res => {
        this.$message.success('操作成功');
        this.showAddressLabelTip = false;
        this.infoWindow.close();
      });
    }
  }
};
window.addFn = function (e) {
  window.$vm.queryAddressLabel();
};
</script>
<style scoped>
.map-warp {
  width: 100%;
  height: 400px;
  position: relative;
  border: 1px solid #e8ecef;
}
.map-icon-common {
  /* background-color: hsla(180, 100%, 50%, 0.7);
    height: 24px;
    width: 24px;
    border: 1px solid hsl(180, 100%, 40%);
    border-radius: 12px;
    box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;
    text-align: center; */
  display: inline-block;
  border-radius: 50%;
  min-width: 24px;
  min-height: 24px;
  padding: 5px;
  background-color: hsla(180, 100%, 50%, 0.7);
  border: 1px solid hsl(180, 100%, 40%);
  box-shadow: hsl(180, 100%, 50%) 0px 0px 1px;
  text-align: center;
  line-height: 1;
  box-sizing: content-box;
  white-space: nowrap;
}
.map-icon-common:before {
  content: '';
  display: inline-block;
  vertical-align: middle;
  padding-top: 100%;
  height: 0;
}
.map-icon-common span {
  display: inline-block;
  vertical-align: middle;
}
.maker-info {
  width: auto;
}
</style>

<style>
.map-location-tip {
  position: relative;
  min-width: 280px;
  max-width: 400px;
  top: 0;
  left: 10px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  background: #fff;
  color: #5a5e66;
}
.map-location-tip:before {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  top: 10px;
  left: -6px;
  border-top: 6px solid transparent;
  border-right: 6px solid #fff;
  border-bottom: 6px solid transparent;
}
.location-addr {
  flex: 1;
}
.join-btn {
  width: 76px;
  margin-left: 10px;
}
</style>
